import React from 'react';
import styled from 'styled-components';
import { Row, Col, Pagination, Empty } from 'antd';
import type { FreePhoto_Base } from '~/common/typescript/models/FreePhoto';
import { FreePhotoCard } from './FreePhotoCard';
import { FreePhotoGridSkeleton } from './FreePhotoGridSkeleton';

interface FreePhotoGridProps {
  photos: FreePhoto_Base[];
  loading: boolean;
  currentPage: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number, pageSize: number) => void;
  onPhotoClick: (photo: FreePhoto_Base) => void;
}

/**
 * Grid layout component for displaying FreePhotos
 */
export const FreePhotoGrid: React.FC<FreePhotoGridProps> = ({
  photos,
  loading,
  currentPage,
  pageSize,
  totalCount,
  onPageChange,
  onPhotoClick,
}) => {
  if (loading && photos.length === 0) {
    return <FreePhotoGridSkeleton count={8} />;
  }

  if (!loading && photos.length === 0) {
    return (
      <UI_EmptyWrapper>
        <Empty description="Không có ảnh nào" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </UI_EmptyWrapper>
    );
  }

  return (
    <UI_Wrapper>
      <Row gutter={[16, 16]}>
        {photos.map((photo) => (
          <Col key={photo.uuid} xs={24} sm={12} md={8} lg={6} xl={6}>
            <FreePhotoCard photo={photo} onClick={() => onPhotoClick(photo)} />
          </Col>
        ))}
      </Row>

      {totalCount > pageSize && (
        <UI_PaginationWrapper>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalCount}
            onChange={onPageChange}
            showSizeChanger={false}
            showTotal={(total) => `Tổng ${total} ảnh`}
          />
        </UI_PaginationWrapper>
      )}
    </UI_Wrapper>
  );
};

const UI_Wrapper = styled.div`
  padding: 16px;
`;

const UI_EmptyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const UI_PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  padding: 16px 0;
`;
